import { bySport } from "./sportFunctions.ts";

const teamInfos: {
	[key: string]: {
		region: string;
		name: string;
		pop: number;
		colors: [string, string, string];
		jersey: string;
	};
} = {
	ABQ: {
		region: "Albuquerque",
		name: "Thunderbirds",
		pop: 0.9,
		colors: ["#ffd404", "#c80c2c", "#000000"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	ANC: {
		region: "Anchorage",
		name: "Glaciers",
		pop: 0.4,
		colors: ["#3bd0e8", "#f96b09", "#fabf09"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football4",
			hockey: "hockey",
		}),
	},
	ATL: {
		region: "Atlanta",
		name: "Gold Club",
		pop: 5.3,
		colors: ["#291091", "#ae7c00", "#00d1df"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	BAL: {
		region: "Baltimore",
		name: "Crabs",
		pop: 2.7,
		colors: ["#89bfd3", "#7a1319", "#07364f"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football3",
			hockey: "hockey",
		}),
	},
	BOS: {
		region: "Boston",
		name: "Massacre",
		pop: 7.3,
		colors: ["#ffffff", "#e70000", "#003188"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	BKN: {
		region: "Brooklyn",
		name: "Bagels",
		pop: 21.5,
		colors: ["#034757", "#67c7e9", "#b78254"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	CHA: {
		region: "Charlotte",
		name: "Queens",
		pop: 1.5,
		colors: ["#009e87", "#541f3e", "#ffffff"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	CIN: {
		region: "Cincinnati",
		name: "Riots",
		pop: 1.6,
		colors: ["#000000", "#c11616", "#2966ef"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	CLE: {
		region: "Cleveland",
		name: "Curses",
		pop: 1.7,
		colors: ["#211e1e", "#f8e3cc", "#3f1c59"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	DAL: {
		region: "Dallas",
		name: "Snipers",
		pop: 6.6,
		colors: ["#000000", "#e08200", "#436431"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	DEN: {
		region: "Denver",
		name: "High",
		pop: 2.7,
		colors: ["#2b8643", "#163a1c", "#a1d297"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football",
			hockey: "hockey",
		}),
	},
	DET: {
		region: "Detroit",
		name: "Muscle",
		pop: 4.0,
		colors: ["#007681", "#d6d6d6", "#ffa400"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	HOU: {
		region: "Houston",
		name: "Apollos",
		pop: 6.2,
		colors: ["#4c91c2", "#c4c4c3", "#ffffff"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	IND: {
		region: "Indianapolis",
		name: "Crossroads",
		pop: 1.6,
		colors: ["#e79f02", "#00246d", "#ffffff"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	KC: {
		region: "Kansas City",
		name: "Sauce",
		pop: 1.6,
		colors: ["#8f2100", "#ffb500", "#d4731c"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	LA: {
		region: "Los Angeles",
		name: "Lowriders",
		pop: 15.6,
		colors: ["#00008b", "#ffaf28", "#ff24ee"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	LAE: {
		region: "Los Angeles",
		name: "Earthquakes",
		pop: 15.6,
		colors: ["#aeaeae", "#ea4b0f", "#dedddd"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	LV: {
		region: "Las Vegas",
		name: "Blue Chips",
		pop: 2.1,
		colors: ["#1c73bb", "#ffd600", "#0c5983"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	MEM: {
		region: "Memphis",
		name: "Blues",
		pop: 1.3,
		colors: ["#000000", "#ff6c49", "#00aedc"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey4",
		}),
	},
	MIA: {
		region: "Miami",
		name: "Cyclones",
		pop: 6.1,
		colors: ["#4ac1c0", "#d8519d", "#f15949"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	MIL: {
		region: "Milwaukee",
		name: "Cheesemakers",
		pop: 1.5,
		colors: ["#003600", "#fdc05f", "#007800"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey4",
		}),
	},
	MIN: {
		region: "Minneapolis",
		name: "Blizzard",
		pop: 2.8,
		colors: ["#8accdc", "#3d2971", "#ed9a22"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football4",
			hockey: "hockey",
		}),
	},
	MXC: {
		region: "Mexico City",
		name: "Aztecs",
		pop: 20.5,
		colors: ["#1a9190", "#510f0f", "#eb5924"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football",
			hockey: "hockey3",
		}),
	},
	NOL: {
		region: "New Orleans",
		name: "Bayou",
		pop: 1.1,
		colors: ["#195869", "#4edd61", "#0e3e33"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football4",
			hockey: "hockey4",
		}),
	},
	NYC: {
		region: "New York",
		name: "Bankers",
		pop: 21.5,
		colors: ["#1e73ba", "#ff8500", "#ffffff"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	OAK: {
		region: "Oakland",
		name: "Blue Oaks",
		pop: 0.5,
		colors: ["#316bac", "#dddddd", "#111111"],
		jersey: bySport({
			baseball: "baseball:hat3",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	OKC: {
		region: "Oklahoma City",
		name: "66ers",
		pop: 1.4,
		colors: ["#610000", "#bbb29e", "#e4dfcf"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football4",
			hockey: "hockey",
		}),
	},
	ORL: {
		region: "Orlando",
		name: "Juice",
		pop: 2.2,
		colors: ["#dc5000", "#ffffff", "#0b7648"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	PHI: {
		region: "Philadelphia",
		name: "Cheesesteaks",
		pop: 5.5,
		colors: ["#46bae6", "#ffdb33", "#d9771f"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	PHO: {
		region: "Phoenix",
		name: "Vultures",
		pop: 4.3,
		colors: ["#d17d2a", "#231f20", "#c09867"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	PIT: {
		region: "Pittsburgh",
		name: "Rivers",
		pop: 1.7,
		colors: ["#231f20", "#fbee28", "#fbee26"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	POR: {
		region: "Portland",
		name: "Roses",
		pop: 2.0,
		colors: ["#e41d34", "#1e1e1e", "#e7a9cc"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	SA: {
		region: "San Antonio",
		name: "Churros",
		pop: 2.0,
		colors: ["#4a2b14", "#30d9ff", "#704723"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	SAC: {
		region: "Sacramento",
		name: "Gold Rush",
		pop: 1.8,
		colors: ["#735823", "#e4c649", "#f8e19f"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football5",
			hockey: "hockey",
		}),
	},
	SD: {
		region: "San Diego",
		name: "Pandas",
		pop: 4.7,
		colors: ["#231f20", "#ffffff", "#b2b3b3"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football4",
			hockey: "hockey4",
		}),
	},
	TPA: {
		region: "Tampa",
		name: "Turtles",
		pop: 2.7,
		colors: ["#023a02", "#17cc21", "#eb851e"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey",
		}),
	},
	UTA: {
		region: "Utah",
		name: "Missionaries",
		pop: 2.3,
		colors: ["#7c7c7c", "#000000", "#aea57a"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	VAN: {
		region: "Vancouver",
		name: "Whalers",
		pop: 2.3,
		colors: ["#213063", "#1ea194", "#117568"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	WAS: {
		region: "Washington",
		name: "Monuments",
		pop: 6.2,
		colors: ["#213063", "#c5ae6e", "#ffffff"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},

	// 2021-05-16 - new teams

	AUS: {
		region: "Austin",
		name: "Armadillos",
		pop: 1.7,
		colors: ["#270b51", "#dedfdf", "#ae5717"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey",
		}),
	},
	BUF: {
		region: "Buffalo",
		name: "Wings",
		pop: 1.1,
		colors: ["#07295c", "#f16229", "#d13522"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey",
		}),
	},
	HAW: {
		region: "Hawaii",
		name: "Honu",
		pop: 1,
		colors: ["#21655a", "#e5e1af", "#279c89"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football",
			hockey: "hockey3",
		}),
	},
	JAX: {
		region: "Jacksonville",
		name: "Gators",
		pop: 1.5,
		colors: ["#24d021", "#3281cc", "#29354b"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	OTT: {
		region: "Ottawa",
		name: "Spiders",
		pop: 1.5,
		colors: ["#000000", "#ffffff", "#d10600"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football3",
			hockey: "hockey",
		}),
	},
	QUE: {
		region: "Quebec",
		name: "Voyageurs",
		pop: 0.8,
		colors: ["#00529f", "#eeb210", "#7b2c18"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	SF: {
		region: "San Francisco",
		name: "Unicorns",
		pop: 6.5,
		colors: ["#676ee7", "#48edfe", "#fe696e"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	TOR: {
		region: "Toronto",
		name: "Raccoons",
		pop: 6.6,
		colors: ["#841222", "#ffffff", "#000000"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	VB: {
		region: "Virginia Beach",
		name: "Colonists",
		pop: 1.7,
		colors: ["#88bccd", "#c7741b", "#99442e"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football2",
			hockey: "hockey",
		}),
	},

	// 2021-05-16 - relocated

	CGY: {
		region: "Calgary",
		name: "Mounties",
		pop: 1.4,
		colors: ["#ed1d3d", "#eac494", "#f2b316"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	MON: {
		region: "Montreal",
		name: "Beavers",
		pop: 4,
		colors: ["#5b352a", "#ffffff", "#967fc0"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football3",
			hockey: "hockey",
		}),
	},
	SJ: {
		region: "San Jose",
		name: "Venture Capitalists",
		pop: 6.5,
		colors: ["#0e442e", "#d75f27", "#e7d3ae"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},

	// 2021-05-16 - rebranded

	CHW: {
		region: "Chicago",
		name: "Whirlwinds",
		pop: 9.1,
		colors: ["#272b2a", "#84d5f4", "#84d5f4"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	SEA: {
		region: "Seattle",
		name: "Symphony",
		pop: 3.8,
		colors: ["#47ff47", "#112e5b", "#8f8f8f"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	STL: {
		region: "St. Louis",
		name: "Spirits",
		pop: 2.2,
		colors: ["#5385ed", "#363736", "#fe18fd"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey",
		}),
	},

	// 2022-09-16 - new teams

	BEI: {
		region: "Beijing",
		name: "Celestials",
		pop: 22.4,
		colors: ["#381968", "#ffffff", "#6da8b5"],
		jersey: bySport({
			baseball: "baseball4:hat",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	EDM: {
		region: "Edmonton",
		name: "River Rats",
		pop: 1.3,
		colors: ["#81cdea", "#1a66d6", "#efc997"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	LON: {
		region: "London",
		name: "Monarchs",
		pop: 14.3,
		colors: ["#10143d", "#ffffff", "#c9202a"],
		jersey: bySport({
			baseball: "baseball:hat3",
			basketball: "jersey2",
			football: "football4",
			hockey: "hockey",
		}),
	},
	MNL: {
		region: "Manila",
		name: "Monkey-Eating Eagles",
		pop: 13.5,
		colors: ["#351a06", "#ffb600", "#ddc194"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey4",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	NJ: {
		region: "New Jersey",
		name: "Swamp Dragons",
		pop: 4.6, // Sum of counties around Newark
		colors: ["#23c3be", "#9436c6", "#ea4242"],
		jersey: bySport({
			baseball: "baseball3:hat3",
			basketball: "jersey5",
			football: "football3",
			hockey: "hockey2",
		}),
	},
	PAR: {
		region: "Paris",
		name: "Pigeons",
		pop: 11.1,
		colors: ["#474754", "#4a997c", "#b18d7f"],
		jersey: bySport({
			baseball: "baseball4:hat",
			basketball: "jersey2",
			football: "football4",
			hockey: "hockey3",
		}),
	},
	RIO: {
		region: "Rio de Janeiro",
		name: "Capybaras",
		pop: 12.3,
		colors: ["#f9c922", "#40b265", "#e28e13"],
		jersey: bySport({
			baseball: "baseball3:hat2",
			basketball: "jersey2",
			football: "football5",
			hockey: "hockey4",
		}),
	},
	TOK: {
		region: "Tokyo",
		name: "Kaiju",
		pop: 37.3,
		colors: ["#ffffff", "#e23122", "#000000"],
		jersey: bySport({
			baseball: "baseball2:hat3",
			basketball: "jersey",
			football: "football2",
			hockey: "hockey2",
		}),
	},
	WPG: {
		region: "Winnipeg",
		name: "Warhawks",
		pop: 0.8,
		colors: ["#122075", "#b3bfc8", "#475584"],
		jersey: bySport({
			baseball: "baseball:hat",
			basketball: "jersey5",
			football: "football3",
			hockey: "hockey",
		}),
	},

	// 2023-08-02 - new teams

	BEL: {
		region: "Belgrade",
		name: "Sparrows",
		pop: 1.7,
		colors: ["#8d8066", "#141a3e", "#d5343f"],
		jersey: bySport({
			baseball: "baseball:hat",
			basketball: "jersey",
			football: "football",
			hockey: "hockey",
		}),
	},
	BER: {
		region: "Berlin",
		name: "Bears",
		pop: 6.2,
		colors: ["#247127", "#012304", "#ffffff"],
		jersey: bySport({
			baseball: "baseball:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey2",
		}),
	},
	BUE: {
		region: "Buenos Aires",
		name: "10s",
		pop: 15.4,
		colors: ["#72abe1", "#ffffff", "#fbbe49"],
		jersey: bySport({
			baseball: "baseball:hat3",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	CAI: {
		region: "Cairo",
		name: "Jackals",
		pop: 21.9,
		colors: ["#000000", "#eab744", "#08416b"],
		jersey: bySport({
			baseball: "baseball2:hat",
			basketball: "jersey4",
			football: "football4",
			hockey: "hockey4",
		}),
	},
	JKT: {
		region: "Jakarta",
		name: "Komodo Dragons",
		pop: 33.9,
		colors: ["#443619", "#c4ce65", "#717a1a"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football5",
			hockey: "hockey2",
		}),
	},
	KAU: {
		region: "Kaunas",
		name: "Knights",
		pop: 0.4,
		colors: ["#023d00", "#fcb701", "#961a1a"],
		jersey: bySport({
			baseball: "baseball2:hat3",
			basketball: "jersey",
			football: "football",
			hockey: "hockey3",
		}),
	},
	KEN: {
		region: "Kentucky",
		name: "Buckets",
		pop: 1.4,
		colors: ["#ffffff", "#e62229", "#000000"],
		jersey: bySport({
			baseball: "baseball3:hat",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	MAD: {
		region: "Madrid",
		name: "Matadors",
		pop: 6.3,
		colors: ["#ffffff", "#e23737", "#c19c74"],
		jersey: bySport({
			baseball: "baseball3:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey",
		}),
	},
	MLB: {
		region: "Melbourne",
		name: "Drop Bears",
		pop: 5.2,
		colors: ["#fc7f6f", "#000000", "#92cccc"],
		jersey: bySport({
			baseball: "baseball3:hat3",
			basketball: "jersey4",
			football: "football4",
			hockey: "hockey2",
		}),
	},
	ROM: {
		region: "Rome",
		name: "Centurions",
		pop: 4.3,
		colors: ["#900018", "#f7a706", "#4c0010"],
		jersey: bySport({
			baseball: "baseball4:hat3",
			basketball: "jersey5",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	SIN: {
		region: "Singapore",
		name: "Merlions",
		pop: 6.1,
		colors: ["#043d5d", "#f2e9d2", "#04a99b"],
		jersey: bySport({
			baseball: "baseball4:hat2",
			basketball: "jersey",
			football: "football",
			hockey: "hockey",
		}),
	},
	SYD: {
		region: "Sydney",
		name: "Convicts",
		pop: 5.3,
		colors: ["#ffe468", "#1d2605", "#f65e00"],
		jersey: bySport({
			baseball: "baseball4:hat",
			basketball: "jersey3",
			football: "football5",
			hockey: "hockey4",
		}),
	},

	// 2023-12-23 - new teams
	ATH: {
		region: "Athens",
		name: "Olympians",
		pop: 3.6,
		colors: ["#ffffff", "#ffa500", "#8f8f8f"],
		jersey: bySport({
			baseball: "baseball4:hat",
			basketball: "jersey",
			football: "football",
			hockey: "hockey",
		}),
	},
	CLB: {
		region: "Columbus",
		name: "Cardinals",
		pop: 1.8,
		colors: ["#e9001e", "#ffffff", "#009adf"],
		jersey: bySport({
			baseball: "baseball4:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey2",
		}),
	},
	DEL: {
		region: "Delhi",
		name: "Maharajas",
		pop: 32.9,
		colors: ["#00753c", "#e5dfd4", "#f59438"],
		jersey: bySport({
			baseball: "baseball4:hat3",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	IST: {
		region: "Istanbul",
		name: "Janissaries",
		pop: 15.8,
		colors: ["#b50000", "#ffffff", "#eac56b"],
		jersey: bySport({
			baseball: "baseball3:hat",
			basketball: "jersey4",
			football: "football4",
			hockey: "hockey4",
		}),
	},
	LIS: {
		region: "Lisbon",
		name: "Navigators",
		pop: 2.9,
		colors: ["#002d55", "#daceae", "#0091c9"],
		jersey: bySport({
			baseball: "baseball3:hat3",
			basketball: "jersey5",
			football: "football5",
			hockey: "hockey",
		}),
	},
	PRO: {
		region: "Providence",
		name: "Shoggoths",
		pop: 1.6,
		colors: ["#303443", "#ffff00", "#4f3ad5"],
		jersey: bySport({
			baseball: "baseball2:hat",
			basketball: "jersey",
			football: "football",
			hockey: "hockey2",
		}),
	},
	RAL: {
		region: "Raleigh",
		name: "Red Wolves",
		pop: 1.4,
		colors: ["#ff0000", "#e6a35a", "#3b0000"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	SEL: {
		region: "Seoul",
		name: "Idols",
		pop: 26,
		colors: ["#7575d6", "#ffa3fd", "#11054f"],
		jersey: bySport({
			baseball: "baseball:hat",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey4",
		}),
	},

	// 2025-07-14 - new teams

	AMS: {
		region: "Amsterdam",
		name: "Tulips",
		pop: 2.5,
		colors: ["#002b51", "#ffffff", "#ff55e0"],
		jersey: bySport({
			baseball: "baseball:hat",
			basketball: "jersey",
			football: "football",
			hockey: "hockey",
		}),
	},
	BOG: {
		region: "Bogota",
		name: "Cocaine Hippos",
		pop: 9.8,
		colors: ["#6b727b", "#fb7ca0", "#ffffff"],
		jersey: bySport({
			baseball: "baseball:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey3",
		}),
	},
	BOI: {
		region: "Boise",
		name: "Bluebirds",
		pop: 0.8,
		colors: ["#0480ff", "#031532", "#c3d3e6"],
		jersey: bySport({
			baseball: "baseball:hat3",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey4",
		}),
	},
	BRU: {
		region: "Brussels",
		name: "Griffons",
		pop: 2.5,
		colors: ["#ff8f0d", "#000000", "#7500e3"],
		jersey: bySport({
			baseball: "baseball2:hat",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey2",
		}),
	},
	CHI: {
		region: "Chicago",
		name: "Gangsters",
		pop: 9.1,
		colors: ["#33607a", "#271919", "#a9daf6"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey5",
			football: "football4",
			hockey: "hockey",
		}),
	},
	CPH: {
		region: "Copenhagen",
		name: "Cyclists",
		pop: 2.1,
		colors: ["#c1102e", "#f9edd0", "#b36473"],
		jersey: bySport({
			baseball: "baseball2:hat3",
			basketball: "jersey",
			football: "football",
			hockey: "hockey3",
		}),
	},
	JNB: {
		region: "Johannesburg",
		name: "Aardvarks",
		pop: 4.8,
		colors: ["#7a5b39", "#ffd801", "#00a661"],
		jersey: bySport({
			baseball: "baseball3:hat",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey4",
		}),
	},
	KYV: {
		region: "Kyiv",
		name: "Tridents",
		pop: 3.5,
		colors: ["#fdd900", "#0f2739", "#0480e4"],
		jersey: bySport({
			baseball: "baseball3:hat2",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey2",
		}),
	},
	LAG: {
		region: "Lagos",
		name: "Crowned Eagles",
		pop: 21,
		colors: ["#003022", "#e0e2c1", "#00c765"],
		jersey: bySport({
			baseball: "baseball3:hat3",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey",
		}),
	},
	LIM: {
		region: "Lima",
		name: "Llamas",
		pop: 11.5,
		colors: ["#40182c", "#ffb200", "#006e3f"],
		jersey: bySport({
			baseball: "baseball4:hat",
			basketball: "jersey5",
			football: "football4",
			hockey: "hockey3",
		}),
	},
	MCM: {
		region: "McMurdo Station",
		name: "Emperors",
		pop: 0.001,
		colors: ["#d4e0e3", "#121a34", "#ffffff"],
		jersey: bySport({
			baseball: "baseball4:hat2",
			basketball: "jersey",
			football: "football",
			hockey: "hockey4",
		}),
	},
	MOS: {
		region: "Moscow",
		name: "Cosmonauts",
		pop: 21.5,
		colors: ["#ec6e5f", "#2f3c40", "#7fb1c4"],
		jersey: bySport({
			baseball: "baseball4:hat3",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey2",
		}),
	},
	NSH: {
		region: "Nashville",
		name: "Nightingales",
		pop: 2.1,
		colors: ["#0d1a44", "#ffe576", "#6bb4e9"],
		jersey: bySport({
			baseball: "baseball:hat",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey",
		}),
	},
	OMA: {
		region: "Omaha",
		name: "Outlaws",
		pop: 1,
		colors: ["#1835b6", "#f2bf03", "#9f2400"],
		jersey: bySport({
			baseball: "baseball:hat2",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey3",
		}),
	},
	SGO: {
		region: "Santiago",
		name: "Condors",
		pop: 6.9,
		colors: ["#009aae", "#2e0003", "#ff5760"],
		jersey: bySport({
			baseball: "baseball:hat3",
			basketball: "jersey5",
			football: "football4",
			hockey: "hockey4",
		}),
	},
	STO: {
		region: "Stockholm",
		name: "Bloodbath",
		pop: 2.4,
		colors: ["#000000", "#ee4011", "#725c59"],
		jersey: bySport({
			baseball: "baseball2:hat",
			basketball: "jersey",
			football: "football",
			hockey: "hockey2",
		}),
	},
	THR: {
		region: "Tehran",
		name: "Persian Lions",
		pop: 15.8,
		colors: ["#fbf4d4", "#07002c", "#d96e00"],
		jersey: bySport({
			baseball: "baseball2:hat2",
			basketball: "jersey2",
			football: "football2",
			hockey: "hockey",
		}),
	},
	TLV: {
		region: "Tel Aviv",
		name: "Sabras",
		pop: 4.2,
		colors: ["#ffffff", "#0a3ee4", "#00c6d8"],
		jersey: bySport({
			baseball: "baseball2:hat3",
			basketball: "jersey4",
			football: "football5",
			hockey: "hockey3",
		}),
	},
	TPE: {
		region: "Taipei",
		name: "101s",
		pop: 7,
		colors: ["#007593", "#d8d6c5", "#e46d5c"],
		jersey: bySport({
			baseball: "baseball3:hat",
			basketball: "jersey3",
			football: "football3",
			hockey: "hockey4",
		}),
	},
	WAW: {
		region: "Warsaw",
		name: "Winged Hussars",
		pop: 3.3,
		colors: ["#0e1a31", "#cba45a", "#f60a00"],
		jersey: bySport({
			baseball: "baseball3:hat2",
			basketball: "jersey5",
			football: "football4",
			hockey: "hockey2",
		}),
	},

	// 2025-07-19
	RYD: {
		region: "Riyadh",
		name: "Sabres",
		pop: 7.9,
		colors: ["#005430", "#ffffff", "#005430"],
		jersey: bySport({
			baseball: "baseball3:hat3",
			basketball: "jersey",
			football: "football",
			hockey: "hockey",
		}),
	},
};

export default teamInfos;
